export default __webpack_public_path__ + "static/media/pic3.68b69941.jpg";